"use client";

import React from "react";

//Styles
import * as S from "./styles";

//Image
import UserImage from "@/assets/images/user2.png";

//Components
import Image from "../image";
import { DropdownMenuItem, DropdownMenuSeparator } from "../ui/dropdown-menu";
import { Filter, LogOut, Settings, User } from "lucide-react";
import { UseAuth } from "@/hooks";

//Type
import { DropdownFilterProps } from "@/types";

const DropdownFilter: React.FC<DropdownFilterProps> = ({
  className,
  children,
  dict,
}) => {
  return (
    <S.DropdownProfile>
      <S.ButtonNotfication>
        <Filter /> {dict.Filter}
      </S.ButtonNotfication>
      <S.ProfileContent>{children}</S.ProfileContent>
    </S.DropdownProfile>
  );
};

export default DropdownFilter;
